import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { unitMediaUrls } from './unitImageHelpersRA';
import MediaPreviewModal, { fileKind } from './mediaPreview';

// Read-only list of the unit's images, PDFs and videos with a viewer.
const ImagesViewList = ({ attachments }) => {
    const { t } = useTranslation();
    const [preview, setPreview] = useState(null);

    const rows = (Array.isArray(attachments) ? attachments : []).filter((row) => (row?.fileName || row?.originalFileName) && (row?.fullUrl || row?.url));

    const handleView = (row) => {
        const name = row.fileName || row.originalFileName;
        const urls = unitMediaUrls(row.fullUrl || row.url);
        setPreview({ url: urls[0], urls, name, kind: fileKind(name, '', row.fullUrl || row.url) });
    };

    return (
        <div className=''>
            <table className="table table-bordered">
                <thead className="dynoTable">
                    <tr>
                        <th>{t('common.fileName')}</th>
                        <th>{t('common.remarks')}</th>
                        <th>{t('common.view')}</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, i) => (
                        <tr key={row.id || row.record_Id || i}>
                            <td><input disabled value={row.fileName || row.originalFileName || ''} className="form-control" /></td>
                            <td><input disabled value={row.remarks || ''} className="form-control" /></td>
                            <td>
                                <button className="mainbtnRed" onClick={() => handleView(row)}>{t('common.view')}</button>
                            </td>
                        </tr>
                    ))}
                    {rows.length === 0 && (
                        <tr><td colSpan={3} className="text-center text-muted">{t('unitMaster.imagesFields.noFiles', 'No files uploaded.')}</td></tr>
                    )}
                </tbody>
            </table>
            <MediaPreviewModal preview={preview} onHide={() => setPreview(null)} />
        </div>
    );
};

export default ImagesViewList;
